<template>
  <div class="page" id="page-gift">

    <div class="section" id="section-gift-landing">
      <div class="container">
        <h1>37년간 사랑받은<br/>인슈넷FC의 혜택<br/>6대 사은</h1>
        <p>인슈넷FC 고객이라면<br/>누구보다 특별하고<br/>차별적인 혜택을 누려야 합니다.</p>
        <div  class="fc-bar"  >
            <div class="left"></div>
            <div class="right"></div>
            <div class="dot"></div>
        </div>
        <div class="tag-list">
          <div class="tag-item">#6대사은</div>
          <div class="tag-item">#비교견적</div>
        </div>
      </div>
    </div>

    <div class="section" id="section-gift-introduction">
      <div class="container">
        <div class="section-header">
          <div class="container">
            <element-tab>
              <element-tab-item @click="introductionTab = '24시간 주차알림'" :on="introductionTab == '24시간 주차알림'">24시간 주차알림</element-tab-item>
              <element-tab-item @click="introductionTab = '긴급견인 20km 추가'" :on="introductionTab == '긴급견인 20km 추가'">긴급견인 20km 추가</element-tab-item>
              <element-tab-item @click="introductionTab = '응급치료비 지원'" :on="introductionTab == '응급치료비 지원'">응급치료비 지원</element-tab-item>
              <element-tab-item @click="introductionTab = '12개 보험사 비교견적'" :on="introductionTab == '12개 보험사 비교견적'">12개 보험사 비교견적</element-tab-item>
              <element-tab-item @click="introductionTab = '4대 공개 게시판'" :on="introductionTab == '4대 공개 게시판'">4대 공개 게시판</element-tab-item>
              <element-tab-item @click="introductionTab = 'SNS 보험 정보'" :on="introductionTab == 'SNS 보험 정보'">SNS 보험 정보</element-tab-item>
            </element-tab>
          </div>
        </div>
        <div class="section-body">
          <div class="container">

            <div id="introduction-tab-service" v-if="introductionTab == '24시간 주차알림'">
              <div class="subsection">
                <div class="container">
                  <h2><span class="index">01</span>24시간 주차알림</h2>
                  <ul>
                    <li>
                      <p>서비스내용</p>
                      고객이 인슈넷FC에서 자동차보험을 가입한 후 인슈넷FC 홈페이지에서 주차알림 스티커를 인쇄하여 차 앞 유리에 붙이고 주차하면 출차 요청자가 <p class="text-blue">인슈넷FC 주차알림 전용번호 1599-4100</p>으로 연락하여 출차를 요청하고 인슈넷FC는 고객 휴대폰으로 출차 요청 문자(SMS)를 보냅니다. 고객은 본인의 휴대폰 번호를 공개하지 않고도 출차 요청자에게 양해를 구하거나 또는 차 파손 시 대응할 수 있습니다.
                    </li>
                    <li>
                      <p>유의사항</p>
                      · 고객이 인슈넷FC 홈페이지에서 주차알림 서비스를 직접 신청해야 합니다.<br>
                      · 주차알림 서비스는 인슈넷FC에서 가입한 자동차보험의 유효기간 동안에만 제공됩니다.<br>
                      · 차량 대체, 차 번호 변경, 휴대폰 변경이 있으면 즉시 인슈넷FC에 통지해야만 서비스가 제공됩니다.<br>
                    </li>
                  </ul>
                  <div class="button-list">
                    <router-link :to="{ name: 'Service' }" ><button>서비스 신청하기</button></router-link>
                  </div>
                </div>
              </div>
            </div>

            <div id="introduction-tab-service" v-if="introductionTab == '긴급견인 20km 추가'">
              <div class="subsection">
                <div class="container">
                  <h2><span class="index">02</span>긴급견인 20km 추가</h2>
                  <ul>
                    <li>
                      <p>서비스내용</p>
                      고객이 인슈넷FC에서 자동차보험을 가입하면 <p class="text-blue">매년 20km씩 긴급출동 무료 견인</p> 거리를 적립해 드립니다.
                      고객이 긴급출동 견인 서비스를 이용할 때 보험사가 제공하는 1회당 10km 외의 추가 견인 거리가 발생하면 1회당 최고 50km(단, 적립 거리 이내)까지 견인 요금을 제공합니다.(레카차 기사에게 반드시 정식 견인비 영수증을 받아 인슈넷FC에 제출해야 함)
                    </li>
                    <li>
                      <p>유의사항</p>
                      · 고객이 보험사의 긴급출동 레카차를 이용할 때만 서비스가 제공됩니다.(보험사 서비스를 이용하지 않는 경우는 불가함)<br>
                      · 1일간 1회만 서비스를 제공합니다.(2, 3차 정비 공장 이동은 불가함)<br>
                      · 서비스 이용 후 잔여 거리가 있다면 차후 사용할 수 있습니다.(단, 보험 가입 기간이 종료되고 재가입하지 않았다면 이전의 적립 거리는 모두 소멸됨)<br>
                      · 보상금은 견인 후 1개월 이내에 청구하셔야 합니다. 견인 후 1개월을 초과하여 청구하는 경우에는 보상금이 지급되지 않습니다.<br>
                    </li>
                  </ul>
                  <div class="button-list">
                    <router-link :to="{ name: 'Service'}" ><button>서비스 신청하기</button></router-link>
                  </div>
                </div>
              </div>
            </div>

            <div id="introduction-tab-service" v-if="introductionTab == '응급치료비 지원'">
              <div class="subsection">
                <div class="container">
                  <h2><span class="index">03</span>응급치료비 지원</h2>
                  <ul>
                    <li>
                      <p>서비스내용</p>
                      고객이 인슈넷FC에서 장기 - 생명 보험을 가입한 후 보험 가입기간이 시작된 뒤 1년간 질병 및 상해 사고로 119 구급차를 이용하여 병원 치료를 받으면 <p class="text-blue">3만원의 위로금을 지급</p>해 드립니다.(단, 연 보험료 10% 이내)
                    </li>
                    <li>
                      <p>유의사항</p>
                      · 소방서의 119 구급차로 병원 치료를 받아야만 서비스가 제공됩니다.<br>
                      · 서비스 청구일 현재 유효한 보험 가입자여야 합니다.<br>
                      · 서비스 청구 유효 기간은 119 구급차 이용일로부터 1개월 이내입니다.<br>
                    </li>
                  </ul>
                  <router-link :to="{ name: 'Service' }" ><button>서비스 신청하기</button></router-link>
                </div>
              </div>
            </div>

            <div id="introduction-tab-service" v-if="introductionTab == '12개 보험사 비교견적'">
              <div class="subsection">
                <div class="container">
                  <h2><span class="index">04</span>12개 보험사 비교견적</h2>
                  <ul>
                    <li>
                      <p>서비스내용</p>
                      인슈넷FC는 모든 회원님에게 12개 보험사 비교견적 서비스를 무료로 제공해 드립니다. 인슈넷FC에서 보험료 견적 서비스를 받으신 후 보험을 가입하지 않으셔도 됩니다. 인슈넷FC에서 무료 보험료 견적서를 신청하려면 아래를 클릭하세요.(회원님이 직접 견적서를 신청하지 않는 경우에도 보험 만기가 임박했거나, 회원님께 필요한 사항이 있다면 견적서를 보내드릴 수 있습니다.)
                    </li>
                  </ul>
                  <router-link :to="{ name: 'CompareEstimate', query: { tab: '자동차보험'} }" ><button>비교견적 신청하기</button></router-link>
                </div>
              </div>
            </div>

            <div id="introduction-tab-service" v-if="introductionTab == '4대 공개 게시판'">
              <div class="subsection">
                <div class="container">
                  <h2><span class="index">05</span>4대 공개 게시판</h2>
                  <ul>
                    <li>
                      <p>서비스내용</p>
                      인슈넷FC 회원은 언제든지 <p class="text-blue">Q&A, 잘하는군, 똑바로해, 바라는점</p> 등 원하시는 사항을 전달할 수 있는 4대 공개 게시판을 투명하게 오픈하고 있습니다. 보험 및 금융 업체에서 보기 드문 인슈넷FC만의 고유 서비스입니다.(기존 금주의 안심 메일은 SNS 보험 정보와 함께 수시 제공합니다.)
                    </li>
                  </ul>
                  <router-link :to="{ name: 'BulletinBoard' }" ><button>4대 공개 게시판 바로가기</button></router-link>
                </div>
              </div>
            </div>

            <div id="introduction-tab-service" v-if="introductionTab == 'SNS 보험 정보'">
              <div class="subsection">
                <div class="container">
                  <h2><span class="index">06</span>SNS 보험 정보</h2>
                  <ul>
                    <li>
                      <p>서비스내용</p>
                      인슈넷FC는 페이스북, 트위터, 유튜브, 구글 플러스, 카카오톡 플러스친구 등 다양한 SNS를 통해 보험 정보를 제공하고 있습니다.<br>
                      (기존 제공하던 휴가철 여행 보험 서비스는 개별 피보험자의 자필 서명 의무화 시행으로 부득이 중지하고 SNS 보험정보 서비스로 대체합니다.)
                    </li>
                  </ul>
                  <div class="sns-list">
                    <div class="sns-item"><a href="https://www.instagram.com/insunetfc/" target="_blank"><img :src="'https://insunetfc-www.s3.ap-northeast-2.amazonaws.com/static/icon_sns_instagram3.png'" /></a></div>
                    <div class="sns-item"><a href="http://pf.kakao.com/_Afkxlj/chat" target="_blank"><img :src="'../static/icon_sns_kakaotalk.png'" /></a></div>
                    <div class="sns-item"><a href="https://www.facebook.com/%EC%9D%B8%EC%8A%88%EB%84%B7FC-132253598456903/?modal=admin_todo_tour" target="_blank"> <img :src="'../static/icon_sns_facebook.png'" /></a></div>
                    <div class="sns-item"><a href="https://twitter.com/insunetfc" target="_blank"><img :src="'../static/icon_sns_twitter.png'" /></a></div>
                    <div class="sns-item"><a href="https://www.youtube.com/channel/UCJFA_J1DCE7htDBmm9WvPqA" target="_blank"><img :src="'../static/icon_sns_youtube.png'" /></a></div>
                    <div class="sns-item"><a href="https://blog.naver.com/insunetfc" target="_blank"><img :src="'../static/icon_sns_naver_blog.png'" /></a></div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [ 'tab' ],
  data(){
    return {
      introductionTab: this.$route.query.tab,
    }
  },
  watch: {
    '$route' (n) {
      if(n.name == "Gift") {
        if(this.$route.query.tab) {
          this.introductionTab = this.$route.query.tab;
        }
        else {
          this.introductionTab = "24시간 주차알림";
        }
        if(this.$route.query.tab == "24시간 주차알림" || this.$route.query.tab == "긴급견인 20km 추가") {
          this.$nextTick(() => {
            document.querySelector("body").scrollTop = document.querySelector("body").scrollHeight
          })
        }
      }
    },
    'introductionTab' () {
      if(this.introductionTab != this.$route.query.tab){
        this.$router.replace({
          hash: `#${document.documentElement.scrollTop}`,
          query: { tab : this.introductionTab }
        })
      }

    }
  },
  methods: {
    fetchTab () {
        if(this.$route.query.tab) {
          this.introductionTab = this.$route.query.tab;
        }
        else {
          this.introductionTab = "24시간 주차알림";
        }
    },
  },
  mounted() {
    if(this.$route.query.tab) this.introductionTab = this.$route.query.tab;
    if(this.$route.query.tab == "24시간 주차알림" || this.$route.query.tab == "긴급견인 20km 추가") {
      console.log("M")
      this.$nextTick(() => {
        document.querySelector("body").scrollTop = document.querySelector("body").scrollHeight
      })
    }
  },
}
</script>
